import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import type { FormControlProps } from 'react-bootstrap/FormControl';
import type { FormSelectProps } from 'react-bootstrap/FormSelect';

const controlClass = 'filter-panel__control';

export type FilterSelectProps = FormSelectProps;

export const FilterSelect = React.forwardRef<HTMLSelectElement, FilterSelectProps>(
  ({ className, size = 'sm', ...props }, ref) => (
    <Form.Select
      ref={ref}
      size={size}
      className={`${controlClass} filter-panel__select${className ? ` ${className}` : ''}`}
      {...props}
    />
  ),
);
FilterSelect.displayName = 'FilterSelect';

export type FilterControlProps = FormControlProps;

export const FilterControl = React.forwardRef<HTMLInputElement, FilterControlProps>(
  ({ className, size = 'sm', ...props }, ref) => (
    <Form.Control
      ref={ref}
      size={size}
      className={`${controlClass} filter-panel__input${className ? ` ${className}` : ''}`}
      {...props}
    />
  ),
);
FilterControl.displayName = 'FilterControl';

type FilterInputGroupProps = React.ComponentProps<typeof InputGroup>;

export const FilterInputGroup: React.FC<FilterInputGroupProps> = ({ className, ...props }) => (
  <InputGroup size="sm" className={`filter-panel__input-group${className ? ` ${className}` : ''}`} {...props} />
);
